import { Button, ButtonProps } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../../../../../../../hooks/auth/useAuth';
import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';
import styles from './AddCompanyAccessButton.module.css';
interface AddCompanyAccessButtonProps extends ButtonProps {
  productId?: string;
  certificateId?: string;
}

const AddCompanyAccessButton = ({
  productId,
  certificateId,
  ...restProps
}: AddCompanyAccessButtonProps): JSX.Element | null => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { openDialog } = useDialogContext();

  const onClick = () => {
    if (productId) {
      openDialog('add-company-access-dialog', { productId, type: 'product' });
    } else if (certificateId) {
      openDialog('add-company-access-dialog', { certificateId, type: 'certificate' });
    }
  };

  // If the user has a Pro license, do not show the button (basic users can't even get to that tab, so no need to check)
  if (user?.company?.license === 'pro') {
    return null;
  }

  return (
    <div className={classNames('w-full md:w-auto flex', styles['add-company-access-button'])}>
      <Button
        onClick={onClick}
        label={t('productDetailsPage.tabs.permissionsTab.buttons.addCompanyAccess')}
        icon='pi pi-plus-circle'
        type='button'
        className='w-full md:w-auto md:min-w-max'
        {...restProps}
      />
    </div>
  );
};

export default AddCompanyAccessButton;
